<template>
  <v-toolbar v-if="hasBreadcrumbs" dense flat>
    <v-toolbar-title class="text-caption d-none d-sm-flex">{{
      $t('breadcrumb.youAreHere')
    }}</v-toolbar-title>
    <v-breadcrumbs :items="breadcrumbs" class="pl-1">
      <template v-slot:item="props">
        <v-breadcrumbs-item
          :to="props.item.link"
          active-class=""
          :class="[props.item.disabled && 'disabled']"
        >
          {{ computeText(props.item) }}
        </v-breadcrumbs-item>
      </template>
      <template v-slot:divider>
        <v-icon color="secondary">mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-spacer></v-spacer>
    <router-link v-if="!isRoot" :to="this.previous" class="v-breadcrumbs__item">
      <v-icon x-small text color="secondary">mdi-arrow-left</v-icon
      >{{ $t('breadcrumb.goBack') }}
    </router-link>
  </v-toolbar>
</template>

<script>
import i18n from '@/utils/i18n';
export default {
  data() {
    return {
      breadcrumbs: [],
      accueil: {
        code: 'menu.accueil',
        link: {
          name: 'home',
        },
      },
      previous: {
        name: '',
        params: {},
      },
    };
  },
  computed: {
    hasBreadcrumbs() {
      return this.breadcrumbs.length > 0;
    },
    isRoot() {
      return this.breadcrumbs.length == 1;
    },
  },
  watch: {
    $route(to) {
      this.computeRoute(to);
    },
  },
  mounted() {
    this.computeRoute(this.$route);
  },
  methods: {
    computeRoute(to) {
      var rawBread = [];
      if (to.meta && to.meta.breadcrumb) {
        rawBread = to.meta.breadcrumb(to);
      }
      rawBread.splice(0, 0, this.accueil);
      this.breadcrumbs = rawBread.map((b, i) => {
        return {
          code: b.code,
          link: b.link,
          disabled: i < rawBread.length - 1,
        };
      });
      this.previous.name =
        this.breadcrumbs && this.breadcrumbs.length > 1
          ? this.breadcrumbs[this.breadcrumbs.length - 2].link.name
          : null;
      this.previous.params =
        this.breadcrumbs && this.breadcrumbs.length > 1
          ? this.breadcrumbs[this.breadcrumbs.length - 2].link.params
          : null;

      var titre = 'AGIL';

      //le titre est la derniere page du breadcrumb
      if (this.breadcrumbs && this.breadcrumbs.length > 1) {
        titre = this.computeText(this.breadcrumbs[this.breadcrumbs.length - 1]);
      }
      document.title = titre;
    },
    computeText(b) {
      return i18n.t(b.code);
    },
  },
};
</script>
